import React from 'react'
import style from './spinner.style'

const Spinner = ({ stroke = '#ffffff', width = 38, height = 38 }) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      className="lds-rolling"
      style={{ background: 'none' }}
    >
      <circle
        cx={50}
        cy={50}
        fill="none"
        ng-attr-stroke="{{config.color}}"
        ng-attr-stroke-width="{{config.width}}"
        ng-attr-r="{{config.radius}}"
        ng-attr-stroke-dasharray="{{config.dasharray}}"
        stroke={stroke}
        strokeWidth={6}
        r={35}
        strokeDasharray="164.93361431346415 56.97787143782138"
        transform="rotate(230.46 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="1.9s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  )
}

export default style(Spinner)
